module.exports = __webpack_public_path__ + "static/img/produto_g.7303bbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/refricola/produto_g.png
// module id = YNXo
// module chunks = 0